export default {
    called: '中文',
    langs: {
        'zh': '中文',
        'en': '英文',
        'ja': '日语'
    },
    contact: '立即咨询',
    gloaleTitle: '让任何一门语言变得流利',
    gloaleText: '准备与最好的在线外教 自信地交谈',
    services: '来自全球高品质的外教老师资源',
    serviceContent: '让世界成为您的舒适地带',
    serviceItems: [{
        title: '让自己沉浸在新文化中',
        desc: '与世界各地的语言专家联系'
    }, {
        title: '在需要时获得专家帮助',
        desc: '学习以任何语言解决任何问题'
    }, {
        title: '成功事业',
        desc: '发展您的工作词汇并清晰地交流'
    }, {
        title: '总是说话自然',
        desc: '留下良好的印象并建立对任何语言的信任'
    }],
    items: [{
        title: '专业导师',
        desc: '寻找母语人士和经认证的私人导师'
    }, {
        title: '经过验证的个人资料',
        desc: '我们会仔细检查并确认每位导师的个人资料'
    }, {
        title: '随时学习',
        desc: '在您忙碌的日程的最佳时间参加在线课程。'
    }, {
        title: '付得起的价钱',
        desc: '选择一个适合您预算的经验丰富的导师'
    }],
    teachLabel: '线上线下,准备与最好的外教自信地交谈',
    endLabel: '为您的团队提供一对一的商务语言培训',
    endSmall: '员工可以随时随地练习发音或提高商务语言能力<br>每个导师提供个性化的计划，以帮助学习者实现其短期或长期目标并改善其业务语言',
    just: '不仅仅是学习一门语言',
    justval: '在BBtalk上学习掌握受用一生的技能，培养新的视角，并与来自世界各地的人们建立连接。',
    letStart: '立即开始'

}